import Cookies from 'js-cookie';

import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';
import { LOYALTY_ID, EMAIL_ID } from 'contexts/CruiseSearchContext/constants';

const utagPillTargetedOffersLoaded = () => {
  const interaction = createUserInteraction({
    eventType: TRACKING_ACTION.INTERACTIONS,
    interaction:
      TRACKING_INTERACTION.TARGETED_OFFERS.PILL_TARGETED_OFFERS_LOADED,
  });

  trackEvent(interaction);
};

export const utagShowOfferPill = async (
  query,
  targetedOffersPillClosed,
  targetedOffersPillShow,
  segmentsMatch,
  callback,
) => {
  if (
    !targetedOffersPillShow &&
    !targetedOffersPillClosed &&
    segmentsMatch &&
    !(
      query[LOYALTY_ID.urlParam] ||
      query[EMAIL_ID.urlParam] ||
      Cookies.get(LOYALTY_ID.cookie) ||
      Cookies.get(EMAIL_ID.cookie)
    )
  ) {
    utagPillTargetedOffersLoaded();

    callback();
  }
};
